export let SUBSCRIPTIONS_UJ_NAMES = /*#__PURE__*/function (SUBSCRIPTIONS_UJ_NAMES) {
  SUBSCRIPTIONS_UJ_NAMES["SELECT_BUNDLE"] = "saas-legacy-select-bundle";
  SUBSCRIPTIONS_UJ_NAMES["START_SUBSCRIPTION"] = "saas-legacy-start-subscription";
  SUBSCRIPTIONS_UJ_NAMES["UPGRADE_SUBSCRIPTION"] = "saas-legacy-upgrade-subscription";
  SUBSCRIPTIONS_UJ_NAMES["DOWNGRADE_SUBSCRIPTION"] = "saas-legacy-downgrade-subscription";
  SUBSCRIPTIONS_UJ_NAMES["VIEW_FEATURE_LOSS_ON_DOWNGRADE"] = "saas-legacy-view-feature-loss-on-downgrade-subscription";
  SUBSCRIPTIONS_UJ_NAMES["VIEW_ADDITIONAL_SUBSCRIPTIONS_ON_DOWNGRADE"] = "saas-legacy-view-additional-subscriptions-on-downgrade-subscription";
  SUBSCRIPTIONS_UJ_NAMES["MANAGE_LOCATION"] = "saas-legacy-manage-locations-on-subscription";
  SUBSCRIPTIONS_UJ_NAMES["PAUSE_SUBSCRIPTION"] = "saas-legacy-pause-subscription";
  SUBSCRIPTIONS_UJ_NAMES["RESUME_SUBSCRIPTION"] = "saas-legacy-resume-subscription";
  SUBSCRIPTIONS_UJ_NAMES["UNSUBSCRIBE_SUBSCRIPTION"] = "saas-legacy-unsubscribe";
  return SUBSCRIPTIONS_UJ_NAMES;
}({});

// Used for both saas-legacy-select-bundle and saas-legacy-start-subscription UJs.
export let BUNDLE_TAGS = /*#__PURE__*/function (BUNDLE_TAGS) {
  BUNDLE_TAGS["SUBSCRIPTION_SELECTED"] = "subscription-selected";
  BUNDLE_TAGS["BUNDLE_SELECTED"] = "bundle-selected";
  return BUNDLE_TAGS;
}({});

// Plan token name (e.g. 'appointments-free'), which contains info
// on both the vertical and the tier. Not all of these are in current
// use, but adding all verticals for completeness/future-proofing.